
import { defineComponent, PropType } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/extensions';
import { IExtension } from '@/types/models';
import { IElForm } from '@/types/element';

interface IForm {
  userName: string;
  name: string;
  state: string;
  message: string;
  isFeatured: boolean;
}

interface IState {
  form: IForm;
}

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    extension: {
      type: Object as PropType<IExtension>,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.extension },
    } as IState;
  },
  methods: {
    apiSubmit() {
      api.submit(
        {
          userName: this.form.userName,
          name: this.form.name,
          state: this.form.state,
          message: this.form.message,
          isFeatured: this.form.isFeatured,
        },
        (res) => {
          if (!res.value) return;

          utils.success('插件状态设置成功！');
          this.$emit('submit', this.form);
        },
      );
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    extension(value) {
      this.form = { ...value };
    },
  },
});
